import { render, staticRenderFns } from "./mobile-nav-new.vue?vue&type=template&id=3471ea24&scoped=true"
import script from "./mobile-nav-new.vue?vue&type=script&lang=js"
export * from "./mobile-nav-new.vue?vue&type=script&lang=js"
import style0 from "./mobile-nav-new.vue?vue&type=style&index=0&id=3471ea24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471ea24",
  null
  
)

export default component.exports